<template>
  <sa-page-layout
    :showModalLoading="showModalLoading"
    :pathResource="pathResource"
  >
    <template slot="toolbar">
      <b-button
        class="float-sm-right"
        variant="success btn-toolbar sa-margin-right"
        size="sm"
        @click="onAggiungiModificaAccettazione"
        ><b-icon icon="plus"></b-icon>Nuovo</b-button
      >
    </template>
    <template slot="toolbar-title">{{ title }}</template>
    <template slot="table-filter">
      <b-row class="sa-label-info">
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Codice Fiscale Assistito</label>
          <b-form-input
            v-model="filtro.codiceFiscaleAssistito"
            class="text-upper"
          ></b-form-input>
        </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Codice Fiscale Medico</label>
          <b-form-input
            v-model="filtro.cfMedico"
            class="text-upper"
          ></b-form-input>
        </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
          <label class="sa-label-data">NRE</label>
          <b-row>
            <b-col>  <b-form-input
            v-model="filtro.codiceBar1"
            class="text-upper"
          ></b-form-input></b-col>
            <b-col>       <b-form-input
            v-model="filtro.codiceBar2"
            class="text-upper"
          ></b-form-input></b-col>
          </b-row>
        
           
        </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Tipologia Ricetta</label>
          <b-form-select
            v-model="filtro.tipologiaRicetta"
            :options="tipologiaRicettaOptions"
            class="text-upper"
          >
               <template #first>
              <b-form-select-option :value="null" disabled
                >- Seleziona -</b-form-select-option
              >
            </template>
        
        </b-form-select>
        </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Data creazione dal</label>
          <date-picker
            format="DD/MM/YYYY"
            value-type="timestamp"
            v-model="filtro.dataOraInizio"
            type="date"
          ></date-picker>
        </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Data creazione al</label>
           <date-picker
            format="DD/MM/YYYY"
            value-type="timestamp"
            v-model="filtro.dataOraFine"
            type="date"
          ></date-picker>
        </b-col>
      </b-row>
      <b-row
        class="sa-padding-right text-right"
        style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 2rem"
      >
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <b-button type="submit" v-on:click="submit" variant="info">{{
            this.$i18n.t("patients.lblFind")
          }}</b-button>
          <b-button type="reset" v-on:click="onReset" variant="danger">{{
            this.$i18n.t("patients.lblResetFilter")
          }}</b-button>
        </b-col>
      </b-row>
    </template>
    <template slot="table-body">

      <accettazione-ssn-list-component
        ref="cmpAccettazioneSsnList"
        @openDetail="onOpenDetailRow"
        @beforeLoadData="onBeforeLoadData"
        @afterLoadData="onAfterLoadData"
      />


    
      <b-modal
        ref="mdlAccettazioneSsn"
        :title="title"
        size="xl"
        style="height: 80%; max-height: 80%"
        centered 
        scrollable
      >
        <accettazione-ssn-ricetta-edit-modal-component
          ref="cmpAccettazioneSsnModalComponent"
        @beforeLoadData="onBeforeLoadData"
        @afterLoadData="onAfterLoadData"
        />
        <template #modal-footer>
          <b-button
            size="sm"
            v-b-tooltip.hover
            title="Conferma"
            variant="success btn-toolbar sa-margin-right"
            @click="onConferma()"
            
          >
            <font-awesome-icon icon="check" />
            Conferma
          </b-button>
        </template>
      </b-modal>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/layout/components/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import AccettazioneSsnListComponent from "../components/AccettazioneSsnListaComponent.vue";
import AccettazioneSsnRicettaEditModalComponent from "../components/AccettazioneSsnRicettaViewModalComponent.vue";
import DatePicker from "vue2-datepicker";
//import { jsontest } from "../components/jsontest.js";

export default {
  components: {
    DatePicker,
    SaPageLayout,
    AccettazioneSsnListComponent,
    AccettazioneSsnRicettaEditModalComponent,
  },
  mixins: { UtilityMixin },
  data() {
    return {
      pathResource: "/accettazionessn",
      resultSearchNreCf: [], //risultato dal be.
      rows: 0,
      perPage: 20,
    
      isRicercaComponent: false,
      page: 1,
      filtro: {
        codiceFiscaleAssistito: null,
        tipologiaRicetta:null,
        codiceBar1:null,
        codiceBar2:null,
        dataOraInizio:null,
        dataOraFine:null,
        cfMedico:null
      },
      listKey: 0,
      showModalLoading: false,
      title: "Accettazione SSN",
            tipologiaRicettaOptions: [
        { text: "CONV", value: "CONVEZIONATO" },
        { text: "SSN", value: "SSN" },
        { text: "ROSSA", value: "ROSSA" },
        { text: "PRIVATA", value: "PRIVATA" },
        { text: "DEMATERIALIZZATA", value: "DEMATERIALIZZATA" },
      ],
    };
  },
  mounted() {
    let me = this;
    me.loadData();
  },
  methods: {
    onOpenDetailRow(item) {
      let me = this;
      console.log("OKDASSNLISTAPAGE", item);
      me.$refs.mdlAccettazioneSsn.show();
    },
    onBeforeLoadData() {
      let me = this;
      me.showModalLoading = true;
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
    loadData() {
      let me = this;
      me.setFiltroSessionStorage(me.filtro);
      me.$refs.cmpAccettazioneSsnList.init();
    },
    submit() {
      let me = this;
      me.setFiltroSessionStorage(me.filtro);
      me.$refs.cmpAccettazioneSsnList.init();
    },
    onReset() {
      let me = this;
      me.filtro = {
        codiceFiscaleAssistito: null,
        page: 1,
        forPage: me.forPage,
      };
      me.setFiltroSessionStorage(me.filtro);
      me.$refs.cmpAccettazioneSsnList.init();
    },
    onAggiungiModificaAccettazione(id) {
      let me = this;
      if(id){
        id = "-1"
      }
      me.$router.push("accettazionessn/"+id)
    },
    setFiltroSessionStorage(filtro) {
      let me = this;
      me.filtro.page = me.page;
      me.filtro.forPage = me.perPage;
      sessionStorage.setItem(
        "filtroPageAccettazioneSsn",
        JSON.stringify(filtro)
      );
    },
    onConferma() {
      let me = this;
      console.log("Confermato chiamata REST....");
      console.log(me.jsonData);
    },
  },
};
</script>

<style scoped></style>
